import { DEFAULT_USERNAME, DEFAULT_USER_ID } from "../constants/user";

export const ANONYMOUS_USER = {
  name: DEFAULT_USERNAME,
  id: DEFAULT_USER_ID
};
